import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import {
  showHamburgerMenu,
  hideHamburgerMenu,
  showSearchForm,
  hideSearchForm,
} from '../../../store/actions/menusActions';
import { userLogOut } from '../../../requests/requests';
import { showLogIn } from '../../../store/actions/modalWindowsActions';
import logoSmall from '../../../assets/images/logo/logo_small.svg';
import search from '../../../assets/icons/actions/search.svg';
import SearchForm from '../SearchForm/SearchForm';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import LogIn from '../../ModalWindows/LogIn/LogIn';
import './Header.scss';

export default function Header() {
  const { t } = useTranslation('header');
  const dispatch = useDispatch();
  const {
    isHamburgerMenuActive,
    isSearchFormActive,
  } = useSelector((state) => state.menus);
  const { isLogInVisible } = useSelector((state) => state.modalWindows);

  const toggleHamburgerMenu = () => {
    if (isHamburgerMenuActive) {
      dispatch(hideHamburgerMenu());
    } else {
      dispatch(showHamburgerMenu());
    }
  };

  const logOut = () => {
    userLogOut()
      .then((response) => {
        if (response.status === 200) {
          localStorage.removeItem('AUTH_TOKEN');
        }

        console.log(response.data);
      })
      .catch((error) => {
        console.log(error.message);
      })
      .finally(() => {});

    dispatch(hideHamburgerMenu());
  };

  const showLogInForm = () => {
    dispatch(showLogIn());
    dispatch(hideHamburgerMenu());
  };

  const toggleSearchForm = () => {
    if (isSearchFormActive) {
      dispatch(hideSearchForm());
    } else {
      dispatch(showSearchForm());
    }
  };

  const availableWindowWidth = document.documentElement.clientWidth;

  const wrapper = (
    <div className="wrapper">
      <div className="header-content">
        <div
          className={classNames('hamburger-menu', { active: isHamburgerMenuActive })}
          aria-hidden="true"
          onClick={toggleHamburgerMenu}
        >
          <span />
          <span />
          <span />
        </div>
        <a href="/">
          <img
            className="logo-small"
            src={logoSmall}
            alt="logoSmall"
          />
        </a>
        <nav className={classNames('navigation', { active: isHamburgerMenuActive })}>
          <ul className="list">
            {
              availableWindowWidth > 834
                ? (
                  <>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#main"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('main')}
                      </a>
                    </li>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#services"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('services')}
                      </a>
                    </li>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#activities"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('activities')}
                      </a>
                    </li>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#about-us"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('about_us')}
                      </a>
                    </li>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#news-events"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('news_events')}
                      </a>
                    </li>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#forms"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('forms')}
                      </a>
                    </li>
                  </>
                )
                : (
                  <>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#main"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('main')}
                      </a>
                    </li>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#news-events"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('news_events')}
                      </a>
                    </li>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#activities"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('activities')}
                      </a>
                    </li>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#services"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('services')}
                      </a>
                    </li>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#about-us"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('about_us')}
                      </a>
                    </li>
                    <li className="list__item">
                      <a
                        className="list__link"
                        href="/#forms"
                        onClick={() => dispatch(hideHamburgerMenu())}
                      >
                        {t('forms')}
                      </a>
                    </li>
                  </>
                )
            }
            <li className="list__item">
              <span
                className="list__log-in"
                aria-hidden="true"
                onClick={
                  localStorage.getItem('AUTH_TOKEN')
                    ? logOut
                    : showLogInForm
                }
              >
                {
                  localStorage.getItem('AUTH_TOKEN')
                    ? t('log_out')
                    : t('log_in')
                }
              </span>
            </li>
          </ul>
        </nav>
        <div className="folding-screen" />
        <button
          className="search"
          type="button"
          onClick={toggleSearchForm}
        >
          <img
            src={search}
            alt="search"
          />
        </button>
        <SearchForm
          className={classNames('search-form', { active: isSearchFormActive })}
          hideSearchForm={() => dispatch(hideSearchForm())}
        />
        <LanguageSwitcher />
      </div>
    </div>
  );

  return (
    <>
      <header className="Header fixed">
        {wrapper}
      </header>
      <header className="Header hidden">
        {wrapper}
      </header>
      {
        isLogInVisible && <LogIn />
      }
    </>
  );
}
